import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const Reksadana = (props: IIconProps) => (
  <Icon viewBox="0 0 28 28" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.847 3.003A34.268 34.268 0 0 0 8.66.893a4.684 4.684 0 0 0-3.683 2.882 50.242 50.242 0 0 0-2.494 16.74 4.685 4.685 0 0 0 2.668 3.803 34.268 34.268 0 0 0 14.146 2.114h.01l.014-.002.017-.002a4.684 4.684 0 0 0 3.682-2.88 49.623 49.623 0 0 0 2.495-16.74 4.684 4.684 0 0 0-2.668-3.805Zm-6.807 12.15a1.273 1.273 0 0 1 2.518.376l-.893 5.974a1.273 1.273 0 0 1-2.518-.376l.893-5.974Zm-4.074.979a1.273 1.273 0 0 1 2.518.376l-.67 4.48a1.273 1.273 0 0 1-2.518-.375l.67-4.481Zm-2.625-.214a1.273 1.273 0 0 0-1.447 1.071l-.446 2.987a1.273 1.273 0 1 0 2.518.377l.446-2.987a1.273 1.273 0 0 0-1.07-1.448ZM19.88 5.78a1.27 1.27 0 0 1 1.08 1.465l-.444 2.971a1.273 1.273 0 0 1-2.532-.19l-2.41 1.905a1.273 1.273 0 0 1-1.838-.276l-1.263-1.837-3.327 2.633a1.273 1.273 0 0 1-1.58-1.997l4.394-3.477a1.273 1.273 0 0 1 1.84.277l1.262 1.836 1.548-1.224-.082-.013a1.273 1.273 0 0 1 .376-2.518l2.976.445Z"
      fill="currentColor"
    />
  </Icon>
);

export default Reksadana;
